import { create } from "zustand";

interface PicklistState {
  show: boolean;
  transactionGroupId?: string;
  hidePicklistModal: () => void;
  showPicklistModal: (transactionGroupId: string) => void;
}

const usePicklist = create<PicklistState>()((set) => ({
  transactionGroupId: undefined,
  show: false,
  hidePicklistModal: () =>
    set((state) => ({ ...state, show: false, transactionGroupId: undefined })),
  showPicklistModal: (transactionGroupId: string) =>
    set((state) => ({ ...state, transactionGroupId, show: true })),
}));

export default usePicklist;
